const Error404 = () => {
    return (
        <div className="container my5 alto">
            <div className="row m-auto">
                <div className="col text-white bg-danger text-center p-5 card">
                    <h1>
                        Error 404
                    </h1>
                    <h3>Esta pagina no existe! </h3>
                </div>
            </div>
        </div>
    )
}

export default Error404;